<template>
  <div class="d-flex align-center" :class="wrapperClass">
    <img :src="icon" :width="iconSize" :height="iconSize" alt="" />
    <h4 class="ml-2 section-heading-h">
      {{ label }}
    </h4>
  </div>
</template>

<script>
export default {
  name: "SectionHeading",
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    iconSize: { type: [String, Number], default: 24 },
    wrapperClass: { type: String, default: "docs-title mb-5" },
  },
};
</script>

<style scoped>
.section-heading-h {
  font-size: 18px;
  font-weight: 650;
}
</style>
